/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { ICartItemType } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { EventType } from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/interfaces";
import useEventTrackers from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/useEventTrackers";
import React from "react";
import { useEffect } from "react";

const ViewCartPixel = ({
  cartItems,
  tax,
  value,
  coupon,
  shipping,
  discount,
}: {
  cartItems: ICartItemType[];
  tax: number;
  value: number;
  coupon: string;

  shipping: number;
  discount: number;
}) => {
  const { eventTrackers } = useEventTrackers();
  const handleTimerEnd = () => {
    eventTrackers(EventType.view_cart, [...cartItems], {
      tax,
      value,
      coupon,
      shipping,
      discount,
    });
  };
  useEffect(() => {
    if (!cartItems) return;
    let time = 1;

    const timerId = setInterval(() => {
      if (time === 0) {
        clearInterval(timerId);
        handleTimerEnd();
      } else {
        time -= 1;
      }
    }, 1000);

    return () => clearInterval(timerId);
  }, [cartItems]);

  return <></>;
};

export default ViewCartPixel;
